import { PUBLIC_APP_BASE_PATH } from '$env/static/public';

export const footerData = {
	logo: 'images/ao_fincap_logo_white.svg',
	companyInfo: {
		title: 'ANGELONE FINCAP PRIVATE LIMITED',
		details: [
			'Registered Office: 601, 6th Floor, Ackruti Star, Central Road, MIDC, Andheri East, Mumbai – 400093',
			'CIN: U67120MH1996PTC245680'
		]
	},
	sections: [
		{
			title: 'ABOUT',
			links: [
				{ text: 'About Us', href: `${PUBLIC_APP_BASE_PATH}/#home` },
				{ text: 'LSP Partners', href: `${PUBLIC_APP_BASE_PATH}/#lsp_partners` },
				{ text: 'Contact Us', href: `${PUBLIC_APP_BASE_PATH}/#contact_us` }
			]
		},
		{
			title: 'POLICIES',
			links: [
				{
					text: 'Privacy Policy',
					href: `${PUBLIC_APP_BASE_PATH}/privacy-policy#title-header`,
					target: '_blank'
				},
				{
					text: 'Terms & Conditions',
					href: `${PUBLIC_APP_BASE_PATH}/terms-and-conditions#title-header`,
					target: '_blank'
				},
				{
					text: 'Grievance Redressal',
					href: `${PUBLIC_APP_BASE_PATH}/privacy-policy#grievance`,
					target: '_blank'
				}
			]
		}
	],
	disclaimer: 'AFPL is a Non-Banking Financial Company registered with the Reserve Bank of India.'
};
